export default __webpack_public_path__ + "static/media/fMaltoBuza30.54970389.png";